import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';

import type { MetaProps } from '@repo/ui/src/types/meta';
import type { MediaType } from '@repo/ui/src/types/image';

interface HeaderAssetItem {
  image?: MediaType;
}

interface GridItemData {
  title?: string;
  _meta?: MetaProps;
  headerAsset?: Array<HeaderAssetItem>;
}

interface GridItemProps {
  item?: GridItemData;
}

const GridItem = ({ item }: GridItemProps) => {
  const { title, _meta, headerAsset } = item || {};
  const { deliveryKey } = _meta || {};
  const imgUrl =
    headerAsset && headerAsset.length > 0
      ? buildImageSrc(headerAsset[0].image, 500, 1, 1)
      : buildImageSrc(null, 500, 1, 1);
  const linkObj = buildLinkObj({ link: deliveryKey });

  return (
    <div className="bg-white h-full p-4 sm:p-8">
      <a href={linkObj.href} className="flex flex-col h-full">
        <LazyLoadImage imgComponent={<img src={imgUrl} alt={title} width="100%" />} />
        <div className="flex-1 mt-6">
          <h2 className="tra-text-web-heading-6">{title}</h2>
        </div>
      </a>
    </div>
  );
};

export default GridItem;
